import { useState, useEffect } from 'react';
import { getLogs } from '../services/adminService';

export const useLogs = (params = {}) => {
    const [logs, setLogs] = useState([]);
    const [pagination, setPagination] = useState({});
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const {
        page = 1,
        limit = 10,
        status,
        endpoint,
        apiType,
        language,
        timeframe,
        userId,
        search
    } = params;

    const fetchLogs = async () => {
        try {
            setLoading(true);
            setError(null);
            const data = await getLogs({
                page,
                limit,
                status,
                endpoint,
                apiType,
                language,
                timeframe,
                userId,
                search
            });

            setLogs(data.logs || []);
            setPagination({
                total: data.total,
                totalPages: data.totalPages,
                currentPage: data.currentPage
            });
        } catch (err) {
            setError(err.message);
            console.error('Failed to fetch logs:', err);
            setLogs([]);
            setPagination({});
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogs();
    }, [page, limit, status, endpoint, apiType, language, timeframe, userId, search]);

    const refetch = async () => {
        await fetchLogs();
    };

    return {
        logs,
        pagination,
        loading,
        error,
        refetch
    };
};
